export default "__VITE_ASSET__5AxOa6qP__"